import React from 'react';
import { usePageLoading } from '../../contexts/PageLoadingContext';
import InlineLoader from '../Loader/InlineLoader';

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
  loaderType?: 'card' | 'table' | 'minimal' | 'default';
}

const PageWrapper: React.FC<PageWrapperProps> = ({ 
  children, 
  className = '', 
  loaderType = 'default' 
}) => {
  const { isPageLoading, pageLoadingText } = usePageLoading();

  return (
    <div className={`page-wrapper ${className}`} style={{ position: 'relative', minHeight: '200px' }}>
      {isPageLoading && (
        <InlineLoader 
          text={pageLoadingText} 
          overlay={loaderType !== 'minimal'}
        />
      )}
      {children}
    </div>
  );
};

export default PageWrapper;